import React, { Component } from 'react'

// lib
import classnames from 'classnames'

// ui
import Button from '../../components/uielements/button'
import { Input } from 'antd'

// icon
import { FaPlusCircle } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import userActions from '../../redux/user/actions'

const { Search } = Input

class HeadBar extends Component {
    _onAddUserClick = () => {
        this.props.preAddUser()
        this.props.showDetailModal()
        this.props.addNewUserState(true)
    }
    isHavePermissionAdd = () => {
        const ishavePermission = this.props.userInfo.actions.find(value => {
            return value === 'USER_CREATE'
        })
        console.log('ishavePermission', ishavePermission)
        if (ishavePermission) {
            return true
        } else {
            return false
        }
    }

    render() {
        return (
            <div className={classnames('row', 'HeaderBar')}>
                <div>
                    {this.isHavePermissionAdd() && (
                        <Button
                            type="primary"
                            onClick={() => this._onAddUserClick()}
                        >
                            <FaPlusCircle className="iconButton" />
                            Thêm người dùng
                        </Button>
                    )}
                </div>
                <Search
                    className="SearchBox"
                    placeholder="Nhập để tìm kiếm"
                    onSearch={value => this.props.searchUser()}
                    value={this.props.textSearch}
                    onChange={e => this.props.updateTextSearch(e.target.value)}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        textSearch: state.user.textSearch,
        userInfo: state.auth.userInfo,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        preAddUser: () => {
            dispatch(userActions.action.preAddUser())
        },
        showDetailModal: () => {
            dispatch(userActions.action.showModalCurrentUserInfo())
        },
        updateTextSearch: textSearch => {
            dispatch(userActions.action.updateTextSearch(textSearch))
        },
        searchUser: () => {
            dispatch(userActions.action.searchUser())
        },
        addNewUserState: bool => {
            dispatch(userActions.action.addNewUserState(bool))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeadBar)
